import {Component, ElementRef, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {GoogleTagManagerService} from 'angular-google-tag-manager';
import {AuthService} from '../../../../../auth/shared/services/auth.service';
import {TrackingService} from '../../../../../services/tracking.service';
import {MenuBase} from '../../menu-base/menu-base.component';
import {UserPermissionsQuery} from 'src/app/common/elf-store/user-permissions/user-permissions.query';
import {SUBSCRIPTIONS} from 'src/app/common/utils/constants';
import {AutoUnsubscribe} from 'src/app/decorators/auto-unsubscribe.decorator';
import {UserPermissionsService} from 'src/app/services/user-permissions.service';
import {UserPermissions} from 'src/app/common/elf-store/user-permissions/user-permissions.store';
import {ExcludedOnlyRegTrackModeComponent} from '../../../../../types/only-reg-track-mode.type';
import {FeatureFlagQuery} from '../../../../../common/elf-store/feature-flag/feature-flag.query';
import {ActivityTrackingService} from '../../../../../auth/shared/services/activity-tracking.service';
import {DashboardAccessMap} from '../../../../../../userway/sdk/UserWayApiClient';
import {AmplitudeService} from '../../../../../services/amplitude.service';

export type ShortUserData = {
  fullName: string;
  shortName: string;
  email: string;
};

export enum NavigationUrls {
  AccountManagement = '/account-management',
  BillingInvoice = '/settings/billing-invoices',
  Subscriptions = '/settings/subscriptions',
  General = '/settings/general',
}

@AutoUnsubscribe()
@Component({
  selector: 'mc-my-account-settings',
  templateUrl: './my-account-settings.component.html',
  styleUrls: ['./my-account-settings.component.scss'],
})
export class MyAccountSettingsComponent extends MenuBase implements OnInit {
  @Input() userData: ShortUserData;
  @Input() isAgency: boolean;
  permissions: DashboardAccessMap;

  // [NEW-GROUP] - disabled for ticket DASH-1168
  // groupsFeatureFlag = false;

  constructor(
    protected readonly router: Router,
    protected readonly gtmService: GoogleTagManagerService,
    protected readonly ampliService: AmplitudeService,
    protected readonly trackingService: TrackingService,
    protected readonly activityTrackingService: ActivityTrackingService,
    private readonly authService: AuthService,
    private elementRef: ElementRef,
    private userPermissionsQuery: UserPermissionsQuery,
    private userPermissionsService: UserPermissionsService,
    private featureFlagQuery: FeatureFlagQuery,
  ) {
    super(router, gtmService, trackingService, ampliService);
  }

  get UserPermissions() {
    return UserPermissions;
  }

  get RegTrackMode() {
    return ExcludedOnlyRegTrackModeComponent;
  }

  logout() {
    this.userPermissionsService.resetPermissions();
    this.authService.userLogOut(true);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this[SUBSCRIPTIONS].add(
      this.userPermissionsQuery.userPermissions$.subscribe(permissions => {
        this.permissions = permissions;
      }),
    );
    // [NEW-GROUP] - disabled for ticket DASH-1168
    // this[SUBSCRIPTIONS].add(
    //   this.featureFlagQuery.groupsFeature$.subscribe(groupsFeatureFlag => {
    //     this.groupsFeatureFlag = groupsFeatureFlag;
    //   }),
    // );
  }

  showSettingsMenu() {
    this.showTooltip = true;
  }

  closeSettingsMenu(url?: NavigationUrls): void {
    this.showTooltip = false;

    if (url === this.navigationUrls.AccountManagement) {
      this.activityTrackingService.manageAccountsEvent();
    }
  }

  blurTooltip(event: FocusEvent) {
    if (event?.relatedTarget && !this.elementRef.nativeElement.contains(event.relatedTarget)) {
      this.showTooltip = false;
    }
  }

  navigationUrls = NavigationUrls;
}
